<template>
  <v-ons-page
    class="search-v"
    :visible="showSearchScreen"
    :options="{ animation: animation }"
    @click="detectOutsideClick"
  >
    <v-ons-toolbar style="background-color: #fff;">
      <div class="center">
        <b><font size="4">お店を探す</font></b>
      </div>
    </v-ons-toolbar>
    <div class="content" style="background-color: #fff !important; margin-top: -40px !important; overflow-x: hidden !important;">
      <div v-if="!showDetail">
        <div class="modal-body" style="background-color: #fff;">
          <div class="condition-content" style="text-align: center;">
            <div class="title">
              <router-link to="/map/show"><img :src="mapSearch" style="max-width: 100%;" /></router-link>
            </div>
          </div>
          <div class="condition-content">
            <div style="position:relative;">
              <div class="title" style="position:absolute;top:-2px;"><img :src="titleSearch" style="margin-left:20px;" /></div>
              <div class="title" style="border-bottom:1px solid #000;margin-bottom:12px;"></div>
            </div>
          </div>
          <div class="condition-content">
            <div
              :class="`title border-bottom icon-collapse ${
                isAreaOpen ? 'is-open' : ''
              }`"
              @click="isAreaOpen = !isAreaOpen"
            >
              地域で絞り込み
            </div>
            <area-refine></area-refine>
          </div>

          <div class="condition-content">
            <div class="title border-bottom">店名・業種で絞り込み</div>
            <name-industry-refine
              @searchRequested="submit"
            ></name-industry-refine>
          </div>

          <div class="condition-content">
            <div class="title border-bottom">サービスで絞り込み</div>
            <div class="checkbox-item">
              <label class="label" for="checkbox">
                テイクアウトができるお店
                <input
                  type="checkbox"
                  id="checkbox"
                  :checked="takeOut"
                  @change="takeOutChanged(!takeOut)"
                />
                <span class="checkmark"></span>
              </label>
            </div>

            <div class="checkbox-item">
              <label class="label" for="checkbox2">
                デリバリーができるお店
                <input
                  type="checkbox"
                  id="checkbox2"
                  :checked="delivery"
                  @change="deliveryChanged(!delivery)"
                />
                <span class="checkmark"></span>
              </label>
            </div>
          </div>

          <div class="condition-content">
            <div class="title border-bottom">地域振興ポイントで絞り込み</div>
            <coupon-refine></coupon-refine>
          </div>

          <loading v-if="searchLoading" />
        </div>

        <div class="modal-footer" style="position: fixed; bottom: 0 !important; width: 100%; left: 0; margin-left: 0;">
          <button class="btn btn-search" :disabled="!canSearch" @click="submit">
            この条件で検索
          </button>
          <button
            class="btn btn-cancel"
            :disabled="!canSearch"
            @click="resetPressed"
          >
          <!-- <button
            class="btn btn-cancel"
            :disabled="!cancellable"
            @click="resetPressed"
          > -->
            検索を解除
          </button>
        </div>
      </div>

      <div v-else>
        <shop-details
          :shopId="selectedShopId"
          :shop="selectedShop"
          @closeClicked="closeModal"
        ></shop-details>
      </div>
    </div>
  </v-ons-page>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
// import ModalHeader from "../components/ModalHeader"
import MapSearch from "../assets/map-search.svg"
import TitleSearch from "../assets/search-title.svg"
import NameIndustryRefine from "../components/search/NameIndustryRefine"
import AreaRefine from "../components/search/AreaRefine"
import CouponRefine from "../components/search/CouponRefine"
import detectOutsideClick from "../mixins/detectOutsideClick"

export default {
  data() {
    return {
      showDetail: false,
      selectedShopId: null,
      selectedShop: null,
      isEntered: true,
      search: null,
      isAreaOpen: false,
      isCouponOpen: false,
      mapSearch: MapSearch,
      titleSearch: TitleSearch
    }
  },

  methods: {
    selectShop(shop) {
      this.selectedShopId = shop.id
      this.selectedShop = shop
      this.showDetail = true
    },

    submit() {
      if (!this.canSearch) {
        return
      }

      this.setCancellable(true)

      document.activeElement.blur()
      this.searchMerchants()
      var ele = document.querySelector('.search-v')

      setTimeout(() => {
        ele.style.display = "none"
      }, 1000)
      setTimeout(() => {
        this.requestShopListScreen()
      }, 950)

      // showSearchResultsScreen(value) {
      //   if (value) {
      //     this.requestShopListScreen()
      //   }
      // }
      // var listm = document.querySelector('.desktop-modal')
      // listm.show()
    },

    clearPressed() {
      this.searchTextChanged("")
      this.exitSearchMode()
    },

    resetPressed() {
      this.resetAll()
      this.exitSearchMode()
    },

    ...mapActions("stores", ["searchMerchants", "sortedShops"]),
    ...mapActions("nav", [
      "closeModal",
      "exitSearchMode",
      "requestShopListScreen"
    ]),
    ...mapActions("search", [
      "resetAll",
      "searchTextChanged",
      "takeOutChanged",
      "deliveryChanged",
      "setCancellable"
    ])
  },

  computed: {
    animation() {
      return window.innerWidth > 900 ? "fade" : "lift"
    },

    ...mapGetters("stores", ["searchLoading", "searchEmpty"]),
    ...mapGetters("nav", [
      "showSearchScreen",
      "showShopListScreen",
      "showSearchResultsScreen"
    ]),
    ...mapGetters("search", ["canSearch", "cancellable", "takeOut", "delivery"])
  },

  watch: {
    showSearchResultsScreen(value) {
      if (value) {
        this.requestShopListScreen()
      }
    }
  },

  mixins: [detectOutsideClick],

  components: {
    // ModalHeader,
    NameIndustryRefine,
    AreaRefine,
    CouponRefine
  }
}
</script>

<style src="../components/search/SearchModal.scss" lang="scss"></style>
<style>
  .search-v {
    z-index:10002;
  }
</style>